// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B2Br","label":"styles_label__2YgNp"};